/** @jsx jsx */ //please do not remove this implementation because the css will not be loaded without it
import {css, jsx} from '@emotion/react'
import DatePicker from "react-datepicker";
import React, { useEffect } from "react";

const timePicker = css`
  display: block;
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  height: calc(1.6em + 0.75rem + 5px);
  border-radius: 0.7rem;
`

export function CustomTimePicker({time,handleChangeTime, ...props}) {
    console.log(time)
    return (
        <DatePicker
            selected={time}
            onChange={(date) => handleChangeTime(date)}
            showTimeSelect
            showTimeSelectOnly
            timeIntervals={1}
            timeCaption="Time"
            dateFormat="h:mm aa"
            css={[timePicker]}
            placeholderText="--:--"
            {...props}
        />
    )

}

const renderYearContent = (year) => {
    const tooltipText = `Tooltip for year: ${year}`;
    return <span title={tooltipText}>{year}</span>;
};

export function CustomYearPicker({year, onChange, ...props}) {
        const styleRef = React.useRef(null);

        useEffect(() => {
            let portalRoot = document.getElementById('year-picker-portal');
            if (!portalRoot) {
                portalRoot = document.createElement('div');
                portalRoot.id = 'year-picker-portal';
                portalRoot.style.position = 'relative';
                portalRoot.style.zIndex = '99999';
                document.body.appendChild(portalRoot);
            }

            const style = document.createElement('style');
            style.textContent = `
                #year-picker-portal {
                    position: relative !important;
                    z-index: 99999 !important;
                }
                #year-picker-portal .react-datepicker {
                    z-index: 99999 !important;
                }
                #year-picker-portal .react-datepicker-popper {
                    z-index: 99999 !important;
                }
                .year-picker-popper {
                    z-index: 99999 !important;
                }
            `;
            document.head.appendChild(style);
            styleRef.current = style;

            return () => {
                if (styleRef.current && document.head.contains(styleRef.current)) {
                    document.head.removeChild(styleRef.current);
                }
            };
        }, []);

        return (
            <div style={{ position: 'relative', zIndex: 99999 }}>
                <DatePicker
                    selected={year}
                    onChange={yr=>onChange(yr)}
                    renderYearContent={renderYearContent}
                    showYearPicker
                    dateFormat="yyyy"
                    css={[timePicker]}
                    popperClassName="year-picker-popper"
                    popperPlacement="bottom-start"
                    portalId="year-picker-portal"
                    {...props}
                />
            </div>
        );

}